import {
  ESellerBillingStatus,
  ESellerInvoiceStatus,
  ESellerPaymentAutoStatus,
  ESellerPaymentStatus,
} from '@/enums/seller';

const getSellerInvoiceStatusName = (status: ESellerInvoiceStatus): string => {
  switch (status) {
    case ESellerInvoiceStatus.OK:
      return 'ส่งแล้ว';
    case ESellerInvoiceStatus.ACPT:
      return 'รับแล้ว';
    case ESellerInvoiceStatus.RJCT:
      return 'ปฏิเสธ';
    case ESellerInvoiceStatus.ER:
      return 'เกิดข้อผิดพลาด';
    case ESellerInvoiceStatus.PC:
      return 'กำลังประมวลผล';
    case ESellerInvoiceStatus.PENDING:
      return 'รอส่ง';
    default:
      return 'รอส่ง';
  }
};

const getSellerInvoiceStatusColor = (status: ESellerInvoiceStatus): string => {
  switch (status) {
    case ESellerInvoiceStatus.PC:
      return 'bg-warning text-dark';
    case ESellerInvoiceStatus.ACPT:
      return 'bg-success text-white';
    case ESellerInvoiceStatus.OK:
      return 'bg-primary text-white';
    case ESellerInvoiceStatus.RJCT:
    case ESellerInvoiceStatus.ER:
      return 'bg-danger text-white';
    default:
      return 'bg-warning text-dark';
  }
};

const getSellerInvoiceStatusOptions = () =>
  Object.entries(ESellerInvoiceStatus).map(([key, value]) => ({
    label: getSellerInvoiceStatusName(value as ESellerInvoiceStatus),
    value: value as ESellerInvoiceStatus,
  }));

const getSellerBillingStatusName = (status: ESellerBillingStatus): string => {
  switch (status) {
    case ESellerBillingStatus.ACPT:
      return 'รับแล้ว';
    case ESellerBillingStatus.OK:
      return 'ส่งแล้ว';
    case ESellerBillingStatus.RJCT:
      return 'ปฏิเสธ';
    default:
      return 'รอส่ง';
  }
};

const getSellerBillingStatusColor = (status: ESellerInvoiceStatus): string => {
  switch (status) {
    case ESellerInvoiceStatus.PC:
      return 'bg-warning text-dark';
    case ESellerInvoiceStatus.ACPT:
      return 'bg-success text-white';
    case ESellerInvoiceStatus.OK:
      return 'bg-primary text-white';
    case ESellerInvoiceStatus.ER:
      return 'bg-danger text-white';
    case ESellerInvoiceStatus.RJCT:
      return 'bg-danger text-white';
    default:
      return 'bg-warning text-dark';
  }
};

const getSellerBillingStatusOptions = () =>
  Object.entries(ESellerBillingStatus).map(([key, value]) => ({
    label: getSellerBillingStatusName(value as ESellerBillingStatus),
    value: value as ESellerBillingStatus,
  }));

const getSellerPaymentStatusName = (status: ESellerPaymentStatus): string => {
  switch (status) {
    case ESellerPaymentStatus.ACCC:
      return 'ผู้ขายได้รับยอดชำระแล้ว';
    case ESellerPaymentStatus.CXLD:
      return 'การชำระเงินถูกยกเลิก';
    case ESellerPaymentStatus.ERR:
      return 'ชำระเงินไม่สำเร็จ';
    case ESellerPaymentStatus.PACC:
      return ' ผู้ซื้อชำระเงินสำเร็จ';
    case ESellerPaymentStatus.PDNG:
      return 'อยู่ระหว่างดำเนินการ';
    default:
      return 'ผู้ขายได้รับยอดชำระแล้ว';
  }
};

const getSellerPaymentStatusColor = (status: ESellerPaymentStatus): string => {
  switch (status) {
    case ESellerPaymentStatus.PDNG:
      return 'bg-warning text-dark';
    case ESellerPaymentStatus.ACCC:
      return 'bg-success text-white';
    case ESellerPaymentStatus.PACC:
      return 'bg-primary text-white';
    case ESellerPaymentStatus.ERR:
      return 'bg-danger text-white';
    case ESellerPaymentStatus.CXLD:
      return 'bg-danger text-white';
    default:
      return 'bg-warning text-dark';
  }
};

const getSellerPaymentStatusOptions = () =>
  Object.entries(ESellerPaymentStatus).map(([key, value]) => ({
    label: getSellerPaymentStatusName(value as ESellerPaymentStatus),
    value: value as ESellerPaymentStatus,
  }));

const getSellerPaymentAutoStatusName = (
  status: ESellerPaymentAutoStatus
): string => {
  switch (status) {
    case ESellerPaymentAutoStatus.OK:
      return 'ยืนยันแล้ว';
    case ESellerPaymentAutoStatus.PDNG:
      return 'รอยืนยัน';
    default:
      return 'รอยืนยัน';
  }
};

const getSellerBillingAutoStatusOptions = () =>
  Object.entries(ESellerPaymentAutoStatus).map(([key, value]) => ({
    label: getSellerPaymentAutoStatusName(value as ESellerPaymentAutoStatus),
    value: value as ESellerPaymentAutoStatus,
  }));

export {
  getSellerInvoiceStatusOptions,
  getSellerInvoiceStatusColor,
  getSellerInvoiceStatusName,
  getSellerBillingStatusColor,
  getSellerBillingStatusName,
  getSellerBillingStatusOptions,
  getSellerPaymentStatusName,
  getSellerPaymentStatusColor,
  getSellerPaymentStatusOptions,
  getSellerPaymentAutoStatusName,
  getSellerBillingAutoStatusOptions,
};
